import script from "./ProviderSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./ProviderSearchBar.vue?vue&type=style&index=0&id=09b80f4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b80f4c"]])

export default __exports__